import { userInfoSync } from 'hub-http/userInfo';
import Routes from 'ContentUtils/Routes';
import { CATEGORY_IDS } from 'ContentUtils/constants/Categories';
export const checkIsWebInteractive = guid => !isNaN(Number(guid));
export const openWebInteractivesEditor = guid => {
  window.open(Routes.inpageEdit(guid, CATEGORY_IDS.WEB_INTERACTIVE), '_blank');
};
export const checkHasAccessToLegacyCtas = () => {
  const {
    user
  } = userInfoSync();
  return user.scopes.includes('cta-access');
};
export const checkHasAccessToCtas = () => {
  const {
    user
  } = userInfoSync();
  const hasWebInteractivesAccess = user.scopes.includes('calls-to-action-read');
  return checkHasAccessToLegacyCtas() || hasWebInteractivesAccess;
};